module.exports = __webpack_public_path__ + "resources/img/main05_jp.b564b60c5bf05a3ee9dc7c04de48ffe0.png";